export const BasisCurrencyId = 34;
export const CountryId_Russia = 43;
export const MarkingConversationMessagesAsUnreadDebouncingTimeout = 500;
